import React, { useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import { useThemeClasses } from '../../hooks/useThemeClasses';

export default function AdminModal({
  open,
  title,
  subtitle,
  onClose,
  children,
  wide = false,
  footer,
}) {
  const tc = useThemeClasses();

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50"
      onClick={onClose}
    >
      <div
        className={`w-full ${wide ? 'max-w-2xl' : 'max-w-md'} max-h-[90vh] overflow-y-auto rounded-2xl border p-5 ${tc.box}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3 mb-4">
          <div className="min-w-0">
            <h3 className={`text-base font-semibold ${tc.textPri}`}>{title}</h3>
            {subtitle ? <p className={`text-xs mt-0.5 ${tc.textSec}`}>{subtitle}</p> : null}
          </div>
          <button
            type="button"
            onClick={onClose}
            className={`p-1.5 rounded-lg border shrink-0 ${tc.btnOutline}`}
            aria-label="Cerrar"
          >
            <FiX className="w-4 h-4" />
          </button>
        </div>
        {children}
        {footer ? <div className="flex gap-2 pt-4">{footer}</div> : null}
      </div>
    </div>
  );
}
